




















import Vue from 'vue';
import LearningTools from '@/tools/learning';
import UserTools from '@/tools/user';
import {
  FirebaseLesson,
  Phrase,
} from '@/store/types';
import ActivityCompleted from '@/components/activity/ActivityCompleted.vue';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  name: 'Drills',
  components: {
    'activity-completed': ActivityCompleted,
  },
  data() {
    return {
      drillIndex: 0,
      drillCompleted: false,
      averageScore: 0,
    };
  },
  async mounted(): Promise<void> {
    const lessonStored = this.$store.state.userLessons
      .find((lesson: FirebaseLesson) => LearningTools.getFirebaseLessonName(this.$store)
        === LearningTools.getFirebaseLessonName(this.$store, lesson.lang_l, lesson.lesson_id));
    this.$store.commit('setMainLoading', false);
    if (lessonStored) {
      await UserTools.updateLessonRecord(this.$store,
        LearningTools.getFirebaseLessonName(this.$store));
    } else {
      await UserTools.createLessonRecord(this.$store,
        LearningTools.getFirebaseLessonName(this.$store));
      await LearningTools.loadLessons(this.$store, this.$store.state.langI,
        this.$store.state.langL, this.$store.state.level.obj_id,
        this.$store.state.unit.unit, this.$store.state.lesson.id);
    }
  },
  computed: {
    originalPhrases(): Array<Phrase> {
      if (this.$store.state.personalizedCourse || (this.$store.state.levelDaily
        && this.$store.state.level.id === LearningTools.LEVEL_DAILY_LESSONS)) {
        return this.$store.state.phrases;
      }
      return this.$store.state.phrases.filter((item: Phrase) => item.lesson_id
        === this.$store.state.lesson.id);
    },
    drillPhrase(): Phrase | null {
      if (this.drillIndex >= 0 && this.drillIndex < this.originalPhrases.length) {
        return this.originalPhrases[this.drillIndex];
      }
      return null;
    },
  },
  methods: {
    onBack() {
      this.$store.commit('setLesson', null);
      this.$router.push({
        path: RoutePaths.LESSONS,
        query: {
          noInit: 'true',
        },
      });
    },
    onNext(payload: number) {
      if (this.drillIndex < this.originalPhrases.length - 1) {
        this.drillIndex += 1;
      } else {
        if (payload) {
          this.averageScore = Math.floor((payload / this.originalPhrases.length) * 100);
        }
        this.drillCompleted = true;
      }
    },
    onCompleted() {
      this.drillCompleted = true;
    },
  },
});

